module.exports = __webpack_public_path__ + "static/img/Rectangle 9.5850f70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Rectangle 9.png
// module id = WIeQ
// module chunks = 1